const map = {
	"./avatar-1.png": 28505,
	"./avatar-10.png": 35037,
	"./avatar-2.png": 88770,
	"./avatar-3.png": 9899,
	"./avatar-4.png": 59988,
	"./avatar-5.png": 76669,
	"./avatar-6.png": 95462,
	"./avatar-7.png": 34479,
	"./avatar-8.png": 9528,
	"./avatar-9.png": 30657,
	"./avatar-s1.png": 60538,
	"./avatar-s2.png": 90705,
	"./avatar-thumb-1.png": 62966,
	"./default.png": 83785,
	"./vector-1.png": 55447,
	"./vector-2.png": 97340,
	"./vector-3.png": 80229,
	"./vector-4.png": 13354
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40630;